// Module
var code = "<input class=\"form-control\" ng-model=\"vm.value\" id=\"field_{{vm.field.id}}\" placeholder=\"hh:mm\" ng-required=\"{{ vm.required ? 'true' : '' }}\"> <p class=\"help-block\" ng-if=\"vm.required && vm.isEmpty\">({{ 'required' | translate }})</p> ";
// Exports
module.exports = code;